export default function dateFilter(state = {}, action)
{
    switch (action.type){
        case 'SET_DATE_FILTER':
            return Object.assign({}, state, {
                dateValue: action.value
              })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dateFilter.js